import { ConditionType, type IConditionDto, ConditionBase, ConditionState, type IConditionLabelOptions, type IVehicle, ConfigurationType } from "..";

export class WashCondition extends ConditionBase
{

    constructor( vehicle: IVehicle, model: IConditionDto )
    {
        super( vehicle, model, ConditionType.Wash, ConfigurationType.Weekly, false );
        this.icon = 'dashboard:wash';
        this.ordinal = 7;
        this.initialise();
    }

    /**
     * Gets the labels for the condition.  The labels are used to provide meaningful
     * user interface statements/prompts that are specific to the condition
     */
    override getLabels(): IConditionLabelOptions 
    {
        return {
            name: "Wash",
            shortName: 'Wash',
            longName: "Wash",
            intervalJustCompletedMessage: "Its just been washed",
            cta: "Find a wash service",
            maintenanceVerb: 'Wash',
            protectedByLabel: 'Your car is protected by'
        };
    }

    /**
     * Gets the description for the interval update for this condition
     * @returns 
     */
    protected override getIntervalDescription()
    {
        if( this.averageOdometerInterval == 0 ) return 'n/a';
        return `Keep your car sparkling with regular visits to the car wash`;
    }

    /**
     * Gets the action message for the service note
     */
    override getActionMessage() 
    {
        switch( this.state )
        {
            case ConditionState.Due: return "You have a wash due, keep your car sparkling with regular visits to the car wash";
            case ConditionState.Overdue: return "You have a wash overdue, keep your car sparkling with regular visits to the car wash";
            case ConditionState.Critical: return "";
            default: return "";
        }
    }
    
}
